<template>
  <section class="ecom body">
    <router-view />
  </section>
</template>

// Do not remove - this has to be here so webpack will hot reload CSS
<style lang="scss">
// body {
//   color: red;
// }
</style>
